import React from "react";

import { MalePerAge } from "../../../../Task/tabs/ProfileDataTab/single/MalePerAge";

export const renderMalePerAge = (label, data, layout, GridBoxComponent) => {
  const {
    user_audience_data: { audienceMen, gendersPerAge },
  } = data;

  const height = layout?.find((item) => item.i === label)?.h;

  return (
    <GridBoxComponent key={label} id={label}>
      <MalePerAge
        audienceMen={audienceMen}
        male={gendersPerAge?.male}
        height={height}
      />
    </GridBoxComponent>
  );
};
